import { useState, useEffect } from "react";
import { CheckInput, Input } from "../../../../../common/Input";
import { useEnumsApi } from "../../../../hooks/useEnumsApi";

export function MaintenanceSetupTab({
  data,
  setData,
  count,
  setCount,
  approverMaintenanceTypes,
  isEdit,
  isViewOnly,
  errorState
}) {
  const { fetchMaintenanceData } = useEnumsApi();
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(false);

  // Styling constants to match ApproverSetupTab
  const labelClass = "block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1";
  const selectClass = (hasError) => `
    w-full p-2.5 border rounded-lg bg-gray-50 outline-none transition-all
    ${hasError ? "border-red-500 ring-1 ring-red-500" : "border-gray-300 focus:ring-2 focus:ring-blue-500"}
    ${(isEdit || isViewOnly) ? "bg-gray-100 cursor-not-allowed text-gray-500" : "cursor-pointer"}
  `;

  useEffect(() => {
    const loadOptions = async () => {
      if (!data.maintenanceTypeId) {
        setDropdownOptions([]);
        return;
      }
      setLoadingOptions(true);
      const optionsMap = await fetchMaintenanceData([data.maintenanceTypeId]);
      setDropdownOptions(optionsMap[data.maintenanceTypeId.toString()] || []);
      setLoadingOptions(false);
    };
    loadOptions();
  }, [data.maintenanceTypeId, fetchMaintenanceData]);

console.log({data});
  return (
    <div className="space-y-2">
      {/* Primary Configuration Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="flex flex-col">
          <label className={labelClass}>Maintenance Category</label>
          <select
            disabled={isEdit || isViewOnly}
            value={data.maintenanceTypeId}
            onChange={(e) => setData({ ...data, maintenanceTypeId: e.target.value, maintenanceValueId: "" })}
            className={selectClass(errorState?.hierarchyCount && !data.maintenanceTypeId)}
          >
            <option value="">Select Category...</option>
            {approverMaintenanceTypes.map(t => <option key={t.value} value={t.value}>{t.name}</option>)}
          </select>
          {errorState?.hierarchyCount && !data.maintenanceTypeId && (
            <span className="text-[10px] text-red-500 mt-1 font-medium italic">Required</span>
          )}
        </div>

        <div className="flex flex-col">
          <label className={labelClass}>Specific Value</label>
          <select
            disabled={isEdit || isViewOnly || !data.maintenanceTypeId || loadingOptions}
            value={data.maintenanceValueId}
            onChange={(e) => setData({ ...data, maintenanceValueId: e.target.value })}
            className={selectClass(errorState?.hierarchyCount && !data.maintenanceValueId)}
          >
            <option value="">{loadingOptions ? "Loading..." : "Select Value..."}</option>
            {dropdownOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          {errorState?.hierarchyCount && !data.maintenanceValueId && (
            <span className="text-[10px] text-red-500 mt-1 font-medium italic">Required</span>
          )}
        </div>
      </div>

      {/* Numerical Setup Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 border-t border-gray-100">
        <div className="flex flex-col">
          <Input
            label="Hierarchy Levels"
            type="number"
            min={1}
            max={10}
            disabled={isViewOnly}
            value={count}
            onChange={(e) => setCount(parseInt(e.target.value) || 1)}
            error={errorState?.hierarchyCount && count < 1}
          // helperText="Number of approval steps required"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 border-t border-gray-100">
        <CheckInput
          name="Status (Active/Inactive)"
          value={data.isActive}
          onChange={(val) => setData({ ...data, isActive: val })}
        />
      </div>

      {/* Info Banner */}
      <div className="rounded-lg border border-blue-100 bg-blue-50 p-4">
        <div className="flex space-x-3">
          <div className="flex-1 text-xs leading-relaxed text-blue-700">
            <p className="font-bold mb-1 uppercase">Rule Logic:</p>
            <p>
              When a request is triggered, the system matches the
              <strong> Category</strong> and <strong>Value</strong>. If an item matches
              multiple rules, the one with the <strong>Highest Priority Level</strong>(if applicable) will be used.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}